import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import AddressBar from "./components/AddressBar";
import BoardGrid from "./components/BoardGrid";
import HotPanel from "./components/HotPanel";
import FeedWall from "./components/FeedWall";
import PollSpecial from "./components/PollSpecial";
import CommentsZone from "./components/CommentsZone";
import CTABanner from "./components/CTABanner";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        {/* 首屏：双栏文+图对开，上疏 */}
        <Hero />
        {/* 直达地址状态条：厚壳运营壳层 */}
        <AddressBar />
        {/* 板块分区：分区感强 */}
        <BoardGrid />
        {/* 今日热议：榜单 + 大卡头条 */}
        <HotPanel />
        {/* 最新瓜田：大小卡混排、图文并重、下密 */}
        <FeedWall />
        {/* 立场投票：互动醒目 */}
        <PollSpecial />
        {/* 评论氛围区 + 更多导航 */}
        <CommentsZone />
        {/* 收尾 CTA */}
        <CTABanner />
      </main>
      <Footer />
    </div>
  );
}